export default "__VITE_ASSET__B9npeZ45__"